import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import { oneOfType, string, bool, arrayOf, func } from 'prop-types';
import { Icon } from '@magalu/stereo-ui-icons';
import { Container, ContainerBox, TextMenu } from './menu-item.styles';
/**
 * A component for setting items menu.
 */

function MenuItem(_ref) {
  let {
    icon,
    text,
    testId,
    onClick
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["icon", "text", "testId", "onClick"]);

  const {
    chevronRight,
    href,
    variation
  } = props;
  const iconColor = variation === 'primary' ? '#FFF' : '#999';
  const typeDiv = href ? 'a' : 'div';
  const label = Array.isArray(text) ? text[0] : text || '';
  const otherLabels = Array.isArray(text) ? text.slice(1) : [];
  return /*#__PURE__*/React.createElement(Container, _extends({
    "data-testid": testId,
    as: typeDiv,
    href: href,
    onClick: onClick
  }, props), icon && /*#__PURE__*/React.createElement(Icon, {
    name: icon,
    color: icon.startsWith('Category') ? '#0086FF' : iconColor
  }), /*#__PURE__*/React.createElement(ContainerBox, null, /*#__PURE__*/React.createElement(TextMenu, _extends({
    isLink: !!href,
    icon: icon
  }, props), label), otherLabels.map(item => /*#__PURE__*/React.createElement(TextMenu, {
    key: item,
    isLink: !!href,
    icon: icon,
    variation: "secondary"
  }, item))), chevronRight && /*#__PURE__*/React.createElement(Icon, {
    name: "ChevronRight",
    color: iconColor
  }));
}

process.env.NODE_ENV !== "production" ? MenuItem.propTypes = {
  chevronRight: bool,
  icon: oneOfType([string, bool]),
  href: string,
  testId: string,
  text: oneOfType([string, arrayOf(string)]).isRequired,
  variation: string,
  onClick: func
} : void 0;
MenuItem.defaultProps = {
  chevronRight: true,
  href: null,
  icon: null,
  testId: '',
  variation: '',
  onClick: () => {}
};
export default MenuItem;